import { App } from "@hireroo/app-store/essential/employee";
import { EmployeeSideBarContent } from "@hireroo/app-store/widget/e/EmployeeSideBarContent";
import { useTranslation } from "@hireroo/i18n";
import type { Pages } from "@hireroo/presentation";
import { generatePath } from "@hireroo/router/api";
import { useTransitionNavigate } from "@hireroo/router/hooks";
import * as React from "react";
import { useParams } from "react-router-dom";

import CompetitionResultDetailFetchContainer from "../../../../widget/v2/e/CompetitionResultDetail/FetchContainer";
import CompetitionResultReportFetchContainer from "../../../../widget/v2/e/CompetitionResultReport/FetchContainer";
import EmployeeHeaderRightContentContainer from "../../../../widget/v2/e/EmployeeHeaderRightContent/Container";
import EmployeeSideBarContentContainer from "../../../../widget/v2/e/EmployeeSideBarContent/Container";
import FooterContainer from "../../../../widget/v2/e/Footer/Container";
import { useNotificationBanner } from "../../../../widget/v2/e/NotificationBanner/Container";
import SnackbarContainer from "../../../../widget/v2/shared/Snackbar/Container";

export type GenerateCompetitionResultDetailPropsArgs = {};

export const useGenerateProps = (_args: GenerateCompetitionResultDetailPropsArgs): Pages.CompetitionResultDetailProps => {
  const { t } = useTranslation();
  const appStatus = App.useStatus();
  const navigate = useTransitionNavigate();
  const NotificationBannerContainer = useNotificationBanner();
  const { id } = useParams<{ id: string }>();
  const resultId = `${id}`;
  const Report = React.useMemo(() => <CompetitionResultReportFetchContainer resultId={resultId} />, [resultId]);

  return {
    layout: {
      openSidebar: EmployeeSideBarContent.useOpenSidebar(),
      onChangeOpenSidebar: open => {
        EmployeeSideBarContent.setOpenSidebar(open);
      },
      //TODO: add loading when dialog status changes
      loading: appStatus === "INITIALIZING",
      NotificationBanner: NotificationBannerContainer,
      HeaderRightContent: <EmployeeHeaderRightContentContainer />,
      SideBarContent: <EmployeeSideBarContentContainer />,
      Footer: <FooterContainer />,
      Snackbar: <SnackbarContainer />,
      sideBarHeader: {
        logo: {
          href: generatePath("/e/home"),
          onClick: () => {
            navigate("/e/home");
          },
        },
      },
      navigationBreadcrumbs: {
        parentLinks: [
          {
            href: generatePath("/e/home"),
            children: t("ホーム"),
            onClick: () => {
              navigate("/e/home");
            },
          },
        ],
        current: t("結果詳細"),
      },
    },
    children: <CompetitionResultDetailFetchContainer resultId={resultId} Report={Report} />,
  };
};
